import { useQuery } from '@tanstack/react-query';

import { getQueryKey } from '@/api/utils/getQueryKey';
import { getResolvedEndpoint } from '@/api/utils/getResolvedEndpoint';
import { handleApiCall } from '@/api/utils/handleApiCall';
import { useAuth } from '@/context/AuthProvider';

export interface DistanceCalculationStatus {
  total_vendors: number;
  calculated_distances: number;
  pending_calculations: number;
  calculation_complete: boolean;
}

export interface DistanceStatusResponse {
  success: boolean;
  data: DistanceCalculationStatus;
}

const METHOD = 'GET';
const ENDPOINT = 'vendor/search/:searchId/distance-status';
export const QUERY_KEY = (searchId: string) => getQueryKey(METHOD, ENDPOINT, { searchId });

export const useDistanceCalculationStatus = (searchId: string, enabled = true) => {
  const { session } = useAuth();

  return useQuery({
    enabled: enabled && !!searchId,
    queryKey: QUERY_KEY(searchId),
    queryFn: async () => {
      const response = await handleApiCall<DistanceStatusResponse>(
        session,
        METHOD,
        getResolvedEndpoint(ENDPOINT, { searchId })
      );
      return response.data;
    },
    refetchInterval: (query) => {
      // Refetch every 3 seconds if calculations are not complete
      const isComplete = query.state.data?.calculation_complete;
      return isComplete ? false : 3000;
    },
    staleTime: 10000, // Consider data stale after 10 seconds
  });
};